// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"copy-to-clipboard_wrapper__PJk2_","success":"copy-to-clipboard_success__ZmazW","nord":"copy-to-clipboard_nord__mAQ2K"};